import { render, staticRenderFns } from "./DownloadProfile.vue?vue&type=template&id=477e9de2&"
import script from "./DownloadProfile.vue?vue&type=script&lang=js&"
export * from "./DownloadProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports